import Task from "../../../model/task/Task";

/**
 * Fetch tasks successful action.
 */
export const TASKS_FETCHED = "TASKS_FETCHED";
export type TASKS_FETCHED = { tasks: Array<Task> }

/**
 * Create task successful action.
 */
export const TASK_CREATED = "TASK_CREATED";
export type TASK_CREATED = { task: Task }

/**
 * Update task successful action.
 */
export const TASK_UPDATED = "TASK_UPDATED";
export type TASK_UPDATED = { task: Task }